<div class="xray-box">
  <div
    class="profile flex justify-center align-items-center study-status-box study-status-box-{{
      studyFile?.studyStatusId || 0
    }}"
  >
    <div *ngIf="!isEmptyStudyFile; else upload"
         class="flex h-100 flex-column justify-space-between align-items-center">
      <div class="box h-100 flex align-items-center justify-content-center study-image">
        <img class="cursor-pointer"
             (click)="emitViewImage()"
             [src]="studyFile?.thumbURL"
             [alt]="studyFile?.thumbFileName" />
      </div>
      <span *ngIf="viewonly">{{ studyFile?.categoryName ?? '&nbsp;&nbsp;'  }}</span>
    </div>

    <ng-template #upload>
      <div class="box h-100 flex align-items-center justify-content-center study-image">
        <app-upload-file *ngIf="viewMode !== ViewMode.APPROVED"
                         [disabled]="uploadDisabled || studyFile?.studyStatusId === StudyStatus.Approved"
                         [categoryName]="mediaCategory.name"
                         [isShowUpload]="isShowUpload"
                         (uploadFiles)="selectFiles($event)"></app-upload-file>
      </div>
    </ng-template>
  </div>

  

  <div *ngIf="viewMode === ViewMode.DRAFT" class="action-section">
    <div *ngIf="
  !isDuplicate &&
    !!studyFile &&
    viewonly &&
    isEditable &&
    studyFile?.studyStatusId === StudyStatus.Submitted
"
         [formGroup]="form">

      <span class="badge rounded-0 w-100 mt-2 p-2 min-height-sys-category  bg-dark-gray" *ngIf="isUnknown">{{ studyFile?.categoryName ?? '&nbsp;&nbsp;'  }}</span>
      <button type="button"
              class="btn btn-primary btn-darker rounded-2 btn-box w-100"
              (click)="openCategoryModal()"
              [disabled]="studyFile.studyFileId === undefined">
        <span *ngIf="mediaCategory">
          <span class="me-1"></span>{{ studyFile?.categoryName ?? '&nbsp;&nbsp;'  }} <i class="fa fa-edit"></i>
        </span>
        <span *ngIf="!mediaCategory">Select Category<i class="fa fa-edit ms-1"></i></span>

      </button>

      <span class="badge rounded-0 w-100 mt-2 p-2 min-height-sys-category  bg-dark-gray" *ngIf="mediaCategory">
        {{ mediaCategory?.name }}

      </span>
    </div>
    <div *ngIf="
        !isDuplicate &&
          !!studyFile &&
          !viewonly &&
          isEditable &&
          studyFile?.studyStatusId !== 4;
        else duplicate
      "
         [formGroup]="form">

      <span class="badge rounded-0 w-100 mt-2 p-2 min-height-sys-category  bg-dark-gray" *ngIf="isUnknown">{{ studyFile?.categoryName ?? '&nbsp;&nbsp;'  }}</span>
      <button type="button"
              class="btn btn-primary btn-darker rounded-2 btn-box w-100"
              (click)="openCategoryModal()"
              [disabled]="studyFile.studyFileId === undefined">
        <span *ngIf="mediaCategory">
          <span class="me-1"></span>{{ studyFile?.categoryName ?? '&nbsp;&nbsp;'  }} <i class="fa fa-edit"></i>
        </span>
        <span *ngIf="!mediaCategory">Select Category<i class="fa fa-edit ms-1"></i></span>

      </button>

      <span class="badge rounded-0 w-100 mt-2 p-2 min-height-sys-category  bg-dark-gray" *ngIf="mediaCategory">
        {{ mediaCategory?.name }}

      </span>
    </div>

    <ng-container *ngIf="!viewonly">
      <button *ngIf="isDuplicate"
              type="button"
              class="btn btn-success w-100"
              (click)="emitUseImageClicked()">
        Use this image
      </button>
      <!--<button
      type="button"
      class="btn btn-primary w-100"
      *ngIf="
        viewMode === ViewMode.DRAFT &&
        !!studyFile &&
        studyFile?.studyStatusId !== 4
      "
      (click)="emitUploadAdditionalClicked(!studyFile?.isAdditional || false)"
    >
      {{
        studyFile?.isAdditional
          ? "Remove from additional images"
          : "Upload as additional image"
      }}
    </button>-->
      <!--<button
      type="button"
      class="btn btn-outline-danger w-100"
      *ngIf="!!studyFile && studyFile?.studyStatusId !== 4"
      (click)="emitDeleteStudyFileClicked()"
    >
      Discard Image
    </button>-->
    </ng-container>
  </div>
  </div>
